import ApiHandler from './ApiHandler';

export default {
    getComments: (commentBoardId, cursor) =>
        ApiHandler.get(
            `/comments/${commentBoardId}${
                cursor ? `?cursor=${encodeURIComponent(cursor)}` : ''
            }`
        ),
    createComment: (commentBoardId, data) =>
        ApiHandler.post(`/comments/${commentBoardId}`, data),
    deleteComment: (commentBoardId, commentId) =>
        ApiHandler.delete(`/comments/${commentBoardId}/${commentId}`)
};
